import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { LOGIN_BUTTON_CLICKED, SIGN_UP_BUTTON_CLICKED } from 'constants/amplitude/AmplitudeEvents';
import { QR_POPUP } from 'constants/ComponentNames';

import amplitude from 'amplitude-js';

import HeaderFixedButton from './HeaderFixedButton';
import styles from './HeaderFixedButtons.module.css';
import { HELP_PAYSEND } from '../../../constants/UrlConstants';
import GetStartedButton from '../common/get-started-button/GetStartedButton';
import QRPopup from '../common/Popups/QRPopup';
import RequestFormPopup from '../common/Popups/RequestFormPopup/RequestFormPopup';
import PromoPopup from '../popup/PromoPopup';

const HeaderFixedButtons = (props) => {
    const [linksStore, setLinksStore] = useState(props.data[0]?.nav_links);
    const [links, setLinks] = useState([]);
    const [pageName, setPageName] = useState({});

    const popupRef = useRef(null);

    const zendeskSubmitRequestLink = `${HELP_PAYSEND}/hc/${props.lang}-${props.country}/requests/new`;

    const selectPopupSnippet = (popupName) => {
        if (popupName === QR_POPUP) {
            popupRef.current?.open(<QRPopup hasAppsBtns={true} popupRef={popupRef} />);
        } else {
            popupRef.current?.open(<RequestFormPopup sendFrom={props.sendFrom} popupRef={popupRef} />);
        }
    };
    const sendAmplitudeEvent = (url) => {
        const eventName = url === '/registration' ? SIGN_UP_BUTTON_CLICKED : LOGIN_BUTTON_CLICKED;
        amplitude.getInstance().logEvent(eventName);
    };

    const linksCodeSnippet =
        Array.isArray(links) &&
        links
            .filter((item) => item !== null)
            .map((link) => {
                return (
                    <li key={link.id}>
                        {pageName && !link.modal_window && link.title && link.url && !link.isExternalButton && (
                            <HeaderFixedButton
                                onClick={() => {
                                    sendAmplitudeEvent(link.url);
                                }}
                                variant={link.color}
                                caption={link.title}
                                href={pageName.name === 'zendesk' ? zendeskSubmitRequestLink : link.url}
                                targetBlank={pageName.name === 'zendesk'}
                                id={link.title}
                                fixedButton={props.fixedHeader}
                            />
                        )}
                        {pageName && link.modal_window && link.title && !link.isExternalButton && (
                            <HeaderFixedButton
                                caption={link.title}
                                variant={link.color}
                                onClick={() => selectPopupSnippet(link.modal_window)}
                                id={link.title}
                                tabIndex={'0'}
                                fixedButton={props.fixedHeader}
                            />
                        )}
                        {link.isExternalButton && link.title && (
                            <GetStartedButton
                                buttonText={link.title}
                                isNavButton
                                promoDarkPage
                                fixedHeader={props.fixedHeader}
                                isMobileMenu={props.isMobileMenu}
                                fixedButton={props.fixedHeader}
                            />
                        )}
                    </li>
                );
            });

    const addPageName = (landing, pageName, isAuth) => {
        const result = { name: '', auth: !!isAuth };
        if (landing) {
            result.name = 'landing';
        } else if (pageName) {
            result.name = pageName;
        } else {
            result.name = 'other';
        }
        setPageName(result);
    };

    const filterLinks = (links, pageData) => {
        switch (pageData.name) {
            case 'landing':
                setLinks(linksStore.filter((item) => item.additional_info == pageData.name && item.authorised_user === pageData.auth));
                break;
            case 'other':
                if (pageData.auth) {
                    setLinks(linksStore.filter((item) => item.authorised_user === pageData.auth));
                } else {
                    setLinks(linksStore.filter((item) => item.additional_info == pageData.name));
                }
                break;

            default:
                setLinks(linksStore.filter((item) => item.additional_info == pageData.name));
        }
    };

    useEffect(() => {
        if (Array.isArray(linksStore) && linksStore.length > 0) {
            addPageName(props.isLanding, props.pageName, props.authUser);
            filterLinks(linksStore, pageName);
        }
    }, [pageName.name]);

    return (
        <>
            {pageName && links && linksCodeSnippet && (
                <ul className={`${styles.buttonsMenu} ${props.hasChatButton ? styles.buttonsMenuAlignedLeft : null}`}>{links && linksCodeSnippet}</ul>
            )}
            <PromoPopup ref={popupRef} />
        </>
    );
};

HeaderFixedButtons.propTypes = {
    authUser: PropTypes.bool,
    data: PropTypes.oneOfType([PropTypes.array, PropTypes.oneOf([null])]),
    isLanding: PropTypes.bool,
};
const mapStateToProps = (state) => {
    return {
        authUser: state.auth.authUser,
        lang: state.extra.noAuthFooter?.language?.lang,
        country: state.extra.noAuthFooter?.language?.country,
    };
};
export default connect(mapStateToProps, null)(HeaderFixedButtons);
